<!--考试列表-->
<template>
    <div class="el-examListInfo">
        <el-row class="page_content">
            <h1 class="head_title_white">
                <el-button type="primary" @click="$closePage()">关 闭</el-button>
            </h1>
            <div class="bg_"></div>
            <el-row style="padding: 20px;">
                <h1 style="margin-bottom:0">
                    {{ courseName }} 期末考试
                </h1>
                <el-row style="border-bottom:1px solid #f3f3f3;padding-bottom:20px;">
                    <div class="zy" v-for='(item,index) in examList' :key="index">
                        <!-- <h1>
                            {{courseName}} 期末考试
                        </h1> -->
                        <p>剩余次数：{{ item.remainExamCount || 0 }} 次</p>
                        <p>考试限时：{{ item.examTimeLimit || 0 }} 分钟</p>
                        <div style="text-align: right;">
                            <el-button type="success" v-if="item.remainExamCount > 0" @click="ksks(item)">
                                {{ item.examStudentStateText }}
                            </el-button>
                            <el-button type="info" @click="ksjl(item.examId)">考试记录</el-button>
                        </div>
                    </div>
                </el-row>
                <el-row style="padding: 20px;" v-show="show_jl">
                    <h1 style="font-size: 20px;">您参加的《{{ courseName }}》考试情况如下：</h1>
                    <el-table
                        :data="tableData"
                        border
                        style="width: 100%;">
                        <el-table-column
                            prop="title"
                            header-align="center"
                            align="center"
                            label="考试次数">
                            <template slot-scope="scope">
                                第 {{ indexNo(scope.$index) }} 次
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="examStudentAddTime"
                            header-align="center"
                            align="center"
                            label="开考时间">
                        </el-table-column>
                        <el-table-column
                            prop="examFraction"
                            header-align="center"
                            align="center"
                            label="得分" width="200">
                            <template slot-scope="scope">
                                <template v-if="!$isEmpty(scope.row.examFinishTime)">
                                    <template v-if="getNowTime - new Date(scope.row.examFinishTime).getTime() > 60000">
                                        <el-link :underline="false" type="primary">{{ scope.row.examFraction }}</el-link>
                                    </template>
                                    <template v-else>
                                        <el-link :underline="false" type="info">正在统计</el-link>
                                    </template>
                                </template>
                                <template v-else>
                                    <el-link :underline="false" type="primary">0</el-link>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="totalScore"
                            header-align="center"
                            align="center"
                            label="总分" width="200">
                            <template slot-scope="scope">
                                <el-link :underline="false" type="danger">{{ scope.row.totalScore }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="title"
                            header-align="center"
                            align="center"
                            label="操作" width="200">
                            <template slot-scope="scope">
                                <el-link :underline="false" :disabled="$isEmpty(scope.row.examFinishTime)"
                                         type="success" @click="viewAnswerSheet(scope.$index)">查看答卷
                                </el-link>
                                <!-- <el-link :underline="false" :disabled ="!$isEmpty(scope.row.examFinishTime)" type="success" style="margin-left:20px;" @click="continueTheExam(scope.$index)">继续考试</el-link> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </el-row>
        </el-row>
    </div>
</template>
<script>
import {getQueryVariable, getStorageKeyForRoleTag, openWithRoleTag} from "../../../common/ulit";

export default {
    name: "SchoolAssignment",
    data() {
        return {
            courseName: this.$Base64.decode(this.$route.query.courseName), //课程名称
            tePlanCourseId: this.$route.query.tePlanCourseId, //课程ID
            tableData: [], //考试记录List
            show_jl: false,
            onExamId: "",
            examList: [], //考试列表List
            getNowTime:"", //当前后端时间
            setInt:null,
            setInt1:null,

        };
    },
    created() {
        if(this.setInt != null){
            clearInterval(this.setInt);
        }
        if(this.setInt1 != null){
            clearInterval(this.setInt1);
        }
        this.getNowDate();
        this.getExamList();
        localStorage.removeItem(getStorageKeyForRoleTag('exam_tag'));
        let this_ = this;
        this.setInt1 = setInterval(function () {
            if (localStorage.getItem(getStorageKeyForRoleTag('exam_tag')) == 1) {
                localStorage.removeItem(getStorageKeyForRoleTag('exam_tag'));
                if (!this_.$isEmpty(this_.onExamId)) {
                    this_.ksjl(this_.onExamId);
                    this_.getExamList(this_.onExamId);
                }
            }
        }, 1000);
    },
    methods: {
        indexNo(i) {
            return this.tableData.length - i;
        },
        getExamList() { //获取考试列表
            this.$store.dispatch("user/getExamList", {tePlanCourseId: this.tePlanCourseId}).then((ret) => {
                if (ret.code === 0 || ret.code === '0') {
                    // this.courseName = ret.courseName;
                    this.examList = ret.data;
                } else {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                }
            });
        },
        ksks(item) {
            localStorage.setItem(getStorageKeyForRoleTag('examName_examination'), this.courseName);
            openWithRoleTag(window.location.origin + '/ExamInfo?examId=' + item.examId + '&tePlanCourseId=' + this.tePlanCourseId);
        },
        ksjl(examId) {
            this.onExamId = examId;
            const loading = this.$loading({
                lock: true,
                text: '加载中......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.show_jl = true;
            this.$store.dispatch("user/getExamLog", {examId: examId}).then((ret) => {
                loading.close();
                if (ret.code === 0 || ret.code === '0') {
                    this.tableData = ret.data;
                } else {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                }
            });
        },
        viewAnswerSheet(index) { //查看答卷
            if(this.getNowTime - new Date(this.tableData[index].examFinishTime).getTime() > 60000){
                openWithRoleTag(window.location.origin + '/ViewAnswerSheetExam?examStudentId=' + this.tableData[index].examStudentId);
            }else{
                this.$message({
                    message: "正在统计，请稍后！",
                    type: 'warning'
                });
            }
            // this.$router.push({name:'ViewAnswerSheet',query:{examStudentId:this.tableData[index].examStudentId}});
        },
        continueTheExam(index) { //继续考试
            localStorage.setItem(getStorageKeyForRoleTag('examName_examination'), this.tableData[index].paperName + "   考试" + this.$chineseNum[this.indexNo(index) - 1]);
            // this.$router.push({name:'Examination',query:{examId:this.tableData[index].examId}});
            openWithRoleTag(window.location.origin + '/Examination?examStudentId=' + this.tableData[index].examStudentId);
        },
        getNowDate(){
          const this_ = this;
          this.$store.dispatch("getNowTime").then((res) => {
            if(res.code == 0){
              this.getNowTime = new Date(res.data).getTime();
              this.setInt = setInterval(()=>{
                this.getNowTime = Number(this.getNowTime) + Number(1000);
              },1000);
            }else{
              this.getNowTime = this.$getNewDate();
              this.setInt = setInterval(()=>{
                this.getNowTime = new Date(this.getNowTime).getTime() + Number(1000);
              },1000);
            }
        	}).catch(function(error) {
        		this_.getNowTime = this_.$getNewDate();
                this_.setInt = setInterval(()=>{
                  this_.getNowTime = new Date(this_.getNowTime).getTime() + Number(1000);
                },1000);
        	});
        }
    },
    beforeDestroyed() {
        if(this.setInt != null){
            clearInterval(this.setInt);
        }
        if(this.setInt1 != null){
            clearInterval(this.setInt1);
        }
    },
};
</script>
<style lang="less">
@import '../../../styles/base.less';

.el-examListInfo {
    .head_title_white {
        text-align: right;
        margin-bottom: 0;
        padding: 10px 30px;
    }

    .bg_ {
        height: 10px;
        background-color: @mainBg;
        margin: 0 -20px;
    }

    .learning_img {
        width: 280px;
        height: 220px;
        border: 1px solid rgb(238, 238, 238);
        float: left;
        margin-right: 20px;
    }

    .el-main {
        min-width: 1200px;
    }

    .zy {
        border: 1px solid rgb(164, 164, 255);
        width: 28%;
        height: 150px;
        border-radius: 10px;
        margin: 25px 1% 0 0;
        padding: 0 20px;
        float: left;
    }

    .odyContainer {
        height: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/exam/ExamList.vue